import { createContext, Ref, useContext } from 'react'
import { FieldError } from 'react-hook-form'

import { isNil } from 'lodash-es'

import { LocationSearchResult } from '@forto-dev/locations-models'

import { AddressFormData } from '../schema'

export type AddressSelectorContextState = {
  addressFromSearch: LocationSearchResult | null
  manualMode: boolean
  label?: string
  required?: boolean
  inputRef?: Ref<unknown>
  disabled?: boolean
  value: AddressFormData | null
  error?: FieldError
  warning?: string
}

export const AddressSelectorContext = createContext<AddressSelectorContextState | null>(null)

export const useAddressSelectorContext = (): AddressSelectorContextState => {
  const ctx = useContext(AddressSelectorContext)

  if (isNil(ctx)) {
    throw new Error('useAddressSelectorContext must be used within a AddressSelectorContext.Provider')
  }

  return ctx
}
